var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSismicidadHistoricaBlanco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,2C115.77,2,2,115.75,2,256.06S115.77,510,256,510,510.05,396.28,510.05,256.06,396.31,2,256,2ZM428.57,428.54A243.14,243.14,0,1,1,480.87,351,243.34,243.34,0,0,1,428.57,428.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.68,182.89l4.43-2.31c-.77-1.49-1.59-3-2.41-4.47l-4.37,2.44C395.14,180,395.93,181.44,396.68,182.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.05,204l-2.87,1H359.43V188.6a5,5,0,0,0-5-5H336.54a5,5,0,0,0-5,5v16.31H301.12V101.77l.8-2.74-.8-.22V72.13h-171a5,5,0,0,0-3.53,1.46L77.49,122.73A5,5,0,0,0,76,126.27h0v281h84A27,27,0,0,0,186.71,430H407.86a27,27,0,0,0,27-27V204.91h-23.5C411.25,204.59,411.16,204.27,411.05,204Zm-69.54-10.38h7.92v31.14h-7.92ZM125.16,89.2v32.07H93.1ZM159.71,310H137a2.51,2.51,0,0,0-2.39,1.78l-2.86,9.41-9.36-30.67a2.5,2.5,0,0,0-4.83.19l-8.16,36.93-3.5-24.92-5,.7,5.43,38.64a2.49,2.49,0,0,0,2.38,2.15h.1a2.5,2.5,0,0,0,2.44-2l9.09-41.16,9,29.41a2.5,2.5,0,0,0,2.39,1.77h0a2.5,2.5,0,0,0,2.39-1.78l4.7-15.49h20.86v33.44H97.77v10h61.94v8.27H97.77v10h61.94v20.57H86v-266h44.13a5,5,0,0,0,5-5V82.13h156V204.91H263.06V188.64a5.07,5.07,0,0,0-5.06-5.07H240.21a5.06,5.06,0,0,0-5.06,5.07v16.27H213.52V138.52H98.43v142h61.28Zm93.35-116.43v31.14h-7.91V193.57Zm-93.35,76.94H108.43v-122h95.09v56.39H185.11A29.5,29.5,0,1,0,156,239a29,29,0,0,0,3.73-.24Zm0-65.6v23.75A19.33,19.33,0,0,1,156,229a19.51,19.51,0,1,1,18.93-24.11ZM424.86,403a17,17,0,0,1-17,17H186.71a17,17,0,0,1-17-17V214.91h65.44v14.74a5.05,5.05,0,0,0,5.06,5.06H258a5.06,5.06,0,0,0,5.06-5.06V214.91h68.45v14.77a5,5,0,0,0,5,5h17.85a5,5,0,0,0,5-5V214.91h65.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.86,174.3l4.28-2.59c-.87-1.44-1.78-2.89-2.69-4.31l-4.2,2.72C390.13,171.48,391,172.89,391.86,174.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.35,150.55l3.73-3.33c-1.13-1.27-2.29-2.52-3.44-3.74L371,146.93C372.13,148.1,373.25,149.32,374.35,150.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.67,132.94c-1.27-1.11-2.58-2.22-3.88-3.29l-3.17,3.87c1.26,1,2.52,2.1,3.75,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M404.67,200.89l4.69-1.74c-.59-1.59-1.21-3.19-1.85-4.74l-4.63,1.89C403.5,197.8,404.1,199.34,404.67,200.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M401,191.76l4.57-2c-.68-1.53-1.4-3.08-2.13-4.61l-4.51,2.17C399.6,188.77,400.29,190.28,401,191.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.15,110.23c-1.51-.76-3-1.52-4.56-2.23l-2.13,4.52c1.48.7,3,1.42,4.42,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.61,120.54c-1.4-1-2.83-1.88-4.25-2.78L340.69,122c1.37.86,2.75,1.77,4.11,2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.83,126.49c-1.35-1-2.71-2.06-4.07-3l-2.93,4c1.31.95,2.64,1.94,3.94,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339,115.11c-1.46-.86-3-1.7-4.41-2.51L332.22,117c1.42.77,2.86,1.59,4.27,2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.51,166l4.12-2.84c-1-1.39-2-2.78-2.95-4.13l-4,3C384.62,163.32,385.58,164.67,386.51,166Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321,105.91c-1.56-.67-3.13-1.33-4.69-1.94l-1.84,4.64c1.51.6,3,1.24,4.54,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.55,102.17c-1.57-.57-3.19-1.12-4.79-1.65l-1.55,4.76c1.55.5,3.12,1,4.64,1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.67,158.1,384.6,155c-1.05-1.33-2.12-2.66-3.2-3.95l-3.83,3.22C378.61,155.52,379.66,156.81,380.67,158.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.09,139.86c-1.19-1.19-2.43-2.37-3.66-3.52L364,140c1.2,1.11,2.39,2.26,3.55,3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.57,407.43h227V251h-227Zm10-146.43h207V397.43h-207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,289.29h19.72V269.57H258.82Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,289.29H306.7V269.57H287Zm5-14.72h9.72v9.72H292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.14,289.29h19.72V269.57H315.14Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363,269.57H343.31v19.72H363Zm-5,14.72h-9.71v-9.72H358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.47,289.29h19.71V269.57H371.47Zm5-14.72h9.71v9.72h-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.5,314.46h19.71V294.74H202.5Zm5-14.72h9.71v9.72H207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.66,314.46h19.72V294.74H230.66Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,314.46h19.72V294.74H258.82Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,314.46H306.7V294.74H287Zm5-14.72h9.72v9.72H292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.14,314.46h19.72V294.74H315.14Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363,294.74H343.31v19.72H363Zm-5,14.72h-9.71v-9.72H358Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.47,314.46h19.71V294.74H371.47Zm5-14.72h9.71v9.72h-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.5,339.63h19.71V319.91H202.5Zm5-14.72h9.71v9.72H207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.66,339.63h19.72V319.91H230.66Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,339.63h19.72V319.91H258.82Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,339.63H306.7V319.91H287Zm5-14.72h9.72v9.72H292Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 315.14,
    y: 319.91,
    width: 19.71,
    height: 19.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 343.31,
    y: 319.91,
    width: 19.71,
    height: 19.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 371.47,
    y: 319.91,
    width: 19.71,
    height: 19.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.5,364.8h19.71V345.08H202.5Zm5-14.72h9.71v9.72H207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.66,364.8h19.72V345.08H230.66Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,364.8h19.72V345.08H258.82Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,364.8H306.7V345.08H287Zm5-14.72h9.72v9.72H292Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.14,364.8h19.72V345.08H315.14Zm5-14.72h9.72v9.72h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.31,364.8H363V345.08H343.31Zm5-14.72H358v9.72h-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.47,364.8h19.71V345.08H371.47Zm5-14.72h9.71v9.72h-9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.5,390h19.71V370.25H202.5Zm5-14.72h9.71V385H207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.66,390h19.72V370.25H230.66Zm5-14.72h9.72V385h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.82,390h19.72V370.25H258.82Zm5-14.72h9.72V385h-9.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287,390H306.7V370.25H287Zm5-14.72h9.72V385H292Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.21,
    y: 150.86,
    width: 41.86,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 222.21,
    y: 167.85,
    width: 60.36,
    height: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSismicidadHistoricaBlanco);
export default __webpack_public_path__ + "static/media/sismicidad_historica_blanco.b03c4d663668c9c120601c9cec0db849.svg";
export { ForwardRef as ReactComponent };